import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoDomicilio, TipoDomicilioProps } from '../../interfaces/catalogos/TipoDomicilioInterface';

export const TipoDomicilio = () => {

    return new Promise<TipoDomicilioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDomicilio/', token)
            .then( ({ data } : { data : TipoDomicilioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoDomicilio = () => {

    return new Promise<TipoDomicilioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoDomicilio/ObtenerTipoDomicilio', token)
            .then( ({ data } : { data : TipoDomicilioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoDomicilio = ( params: TipoDomicilioProps ) => {

    return new Promise<TipoDomicilioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDomicilio/Actualizar', params, token)
            .then( ({ data } : { data : TipoDomicilioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDomicilio });
            });

        }

    });

}

export const AgregarTipoDomicilio = ( params: TipoDomicilioProps ) => {

    return new Promise<TipoDomicilioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoDomicilio/Agregar', params, token)
            .then( ({ data } : { data : TipoDomicilioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoDomicilio });
            });

        }

    });

}
